import axiosClient from ".";
class UserBetHistoryAPI {
  static getUserBetHistory() {
    return axiosClient.get("/bet_histories.json");
  }
}
export default UserBetHistoryAPI;
